import { useState } from 'react';
import { FilterIcon, ListIcon } from '@setvi/shared/components/sicons';
import { STabs } from '@setvi/shared/components';
import { Container, TabsContainer } from './styled';
import { FacetsProps } from '../facets';
import { FiltersContent } from './filters';
import { CategoriesContent, CategoriesContentProps } from './categories';

enum Tabs {
  Categories = 'categories',
  Filters = 'filters'
}

interface BottomLeftWrapperProps {
  filtersProps: FacetsProps;
  categoriesProps: CategoriesContentProps;
}

const iconStyle = {
  width: 14,
  height: 14
};

export const BottomLeftWrapper = ({
  filtersProps,
  categoriesProps
}: BottomLeftWrapperProps) => {
  const [activeTab, setActiveTab] = useState(Tabs.Filters);

  const tabsList = [
    {
      label: 'Categories',
      value: Tabs.Categories,
      icon: <ListIcon fontSize="small" />
    },
    {
      label: 'Filters',
      value: Tabs.Filters,
      icon: <FilterIcon style={iconStyle} />
    }
  ];

  return (
    <Container>
      <TabsContainer>
        <STabs
          variant="fullWidth"
          tabsList={tabsList}
          type="rounded"
          handleTabChange={value => setActiveTab(value as Tabs)}
          currentTab={activeTab}
          tabStyle={{
            padding: '8px 12px'
          }}
          divider={false}
        />
      </TabsContainer>

      {activeTab === Tabs.Categories && (
        <CategoriesContent {...categoriesProps} />
      )}
      {activeTab === Tabs.Filters && <FiltersContent {...filtersProps} />}
    </Container>
  );
};
